import { useState } from "react";
import AlertBox from "../AlertBox";
import { TicketAssignableSelector } from "./TicketAssignableSelector";
import { assignTicket } from "../../api/ticket";

export default function FormUpdateTicket({ ticket, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState({ show: false, message: "", type: "" });
  const [assigned_to_user_id, setAssignedToUserId] = useState("");

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!assigned_to_user_id) {
      setAlert({ show: true, message: "Pilih user terlebih dahulu", type: "warning" });
      return;
    }

    setLoading(true);
    try {
      const { data } = await assignTicket(ticket.id, { assigned_to_user_id });
      if (onSuccess) onSuccess(data.message);
    } catch (error) {
      let message = "";
      if (error.response) {
        let { data } = error.response;
        message = data.message;
      } else {
        message = "Something Error Happened";
      }
      setAlert({ show: true, message, type: "danger" });
    }
    setLoading(false);
  };

  return (
    <div className="card">
      <div className="card-body">
        <h5>Ubah Penugasan</h5>
        <AlertBox {...alert} setAlert={setAlert} />
        <div className="form-group">
          <label>Tugaskan ke: </label>
          <TicketAssignableSelector
            value={assigned_to_user_id}
            onChange={(value) => setAssignedToUserId(value)}
          />
        </div>
        <div className="form-group">
          <button
            type="button"
            className="btn btn-primary"
            disabled={loading}
            onClick={handleSubmit}
          >
            <i className="fa fa-save"></i> {loading ? "Menyimpan..." : "Simpan"}
          </button>
        </div>
      </div>
    </div>
  );
}
